import { useState, type CSSProperties } from 'react';
import type { TimelineStep } from '@repancy/core';
import { testIds } from '../../lib/testIds';

interface StepMarkerProps {
  step: TimelineStep;
  index: number;
  isCurrent: boolean;
  isForkPoint: boolean;
  onClick: () => void;
}

const MARKER_SIZE = 14;

export function StepMarker({ step, index, isCurrent, isForkPoint, onClick }: StepMarkerProps) {
  const [hovered, setHovered] = useState(false);

  const containerStyle: CSSProperties = {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    width: MARKER_SIZE + 8,
    height: MARKER_SIZE + 8,
    flexShrink: 0,
  };

  const markerBase: CSSProperties = {
    width: MARKER_SIZE,
    height: MARKER_SIZE,
    transition: 'background-color 0.15s, border-color 0.15s',
  };

  const circleStyle: CSSProperties = {
    ...markerBase,
    borderRadius: '50%',
    backgroundColor: isCurrent ? 'var(--xp-selection)' : 'transparent',
    border: `2px solid ${isCurrent ? 'var(--xp-selection)' : '#808080'}`,
  };

  const diamondStyle: CSSProperties = {
    ...markerBase,
    transform: 'rotate(45deg)',
    backgroundColor: isCurrent ? '#cc0000' : 'transparent',
    border: `2px solid #cc0000`,
  };

  const tooltipStyle: CSSProperties = {
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    marginBottom: 4,
    padding: '2px 6px',
    backgroundColor: '#ffffcc',
    border: '1px solid #000000',
    fontFamily: "var(--xp-font-body)",
    fontSize: 11,
    whiteSpace: 'nowrap',
    pointerEvents: 'none',
    zIndex: 1000,
  };

  return (
    <div
      style={containerStyle}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      data-testid={testIds.timeline.stepMarker(index)}
    >
      <div style={isForkPoint ? diamondStyle : circleStyle} />
      {hovered && (
        <div style={tooltipStyle}>
          Step {index + 1}: {step.label}
        </div>
      )}
    </div>
  );
}
